import api from ".";
  
export const apiCreateVault = async (payload: { email: string }) => {
  return await api.post('/vault/create', payload);
};
export const apiImportVault = async (payload: { vaultId: string }) => {
  return await api.post('/vault/import', payload);
};
export const apiVerifyVault = async (payload: {
  email: string;
  otp: string;
}) => {
  return await api.post('/vault/verify-otp', payload);
};